// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"26ee2d17","453":"5f80d25b"}[chunkId] + ".chunk.js";
};